import {Link} from '@inertiajs/react';
import {Image} from "react-bootstrap";

const Footer = () => {
    return (
        <>
            <div className="footers-area pb-125 position-relative z-2">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="footer-single-item mb-4 text-center">
                                <Link href="/" className="footer-logo d-inline-block mb-4">
                                    <Image
                                        src="/images/landing/yv_logo.svg"
                                        alt="Young Voices"
                                        width={132}
                                        height={34}
                                    />
                                </Link>

                                <p className="mb-0">
                                    Grove Mews, 1 Coronation Road, Birchgrove,<br/>
                                    Cardiff, CF14 4QY<br/>
                                    Young Voices (UK) Ltd - Company number 03830893
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="copyright-area bg-white text-center py-4">
                <div className="container">
                    <p className="fs-14 mb-0">
                        &copy; {new Date().getFullYear()} Young Voices (UK) Ltd. All rights reserved.
                    </p>
                </div>
            </div>
        </>
    );
};

export default Footer;
